import React, { ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { cn } from '@/lib/utils';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Thêm style đặc biệt cho swiper-wrapper
import './styles.css';

interface MobileCarouselProps {
  items: ReactNode[];
  slidesPerView?: number | 'auto';
  spaceBetween?: number;
  loop?: boolean;
  autoplay?: boolean;
  pagination?: boolean;
  className?: string;
  slideClassName?: string;
  centeredSlides?: boolean;
  effect?: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' | 'creative';
  breakpoints?: {
    [width: number]: {
      slidesPerView: number | 'auto';
      spaceBetween: number;
    };
  };
}

const MobileCarousel: React.FC<MobileCarouselProps> = ({
  items,
  slidesPerView = 'auto',
  spaceBetween = 16,
  loop = false,
  autoplay = false,
  pagination = false,
  className,
  slideClassName,
  centeredSlides = false,
  effect = 'slide',
  breakpoints,
}) => {
  // Tạo cấu hình pagination tốt hơn
  const paginationOptions = pagination 
    ? { 
        clickable: true,
        dynamicBullets: true,
        renderBullet: (index: number, className: string) => {
          return `<span class="${className}"></span>`;
        }
      } 
    : false;

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      loop={loop}
      effect={effect}
      centeredSlides={centeredSlides}
      pagination={paginationOptions}
      autoplay={autoplay ? { delay: 3000, disableOnInteraction: false } : false}
      breakpoints={breakpoints}
      className={cn("w-full mobile-carousel", className)}
      style={{ height: 'auto' }}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index} className={cn("h-auto", slideClassName)}>
          {item}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default MobileCarousel; 